__turbopack_context__.v({
  "allLink": "activity-module__9qIHTq__allLink",
  "back": "activity-module__9qIHTq__back",
  "detailPane": "activity-module__9qIHTq__detailPane",
  "feedPane": "activity-module__9qIHTq__feedPane",
  "headerBar": "activity-module__9qIHTq__headerBar",
  "left": "activity-module__9qIHTq__left",
  "page": "activity-module__9qIHTq__page",
  "placeholder": "activity-module__9qIHTq__placeholder",
  "split": "activity-module__9qIHTq__split",
});
